<div class="top-menu header-section">
    <div class="left-side-header">
        <div
            class="hamburger-container"
            (click)="toggleMenu()"
            (keypress)="toggleMenu()"
            [class.change]="menuService.menuState$ | async"
            tabindex="0"
            role="button"
            [attr.aria-label]="
                ((menuService.menuState$ | async)
                    ? 'a11y.closeMenu'
                    : 'a11y.openMenu'
                ) | translate
            "
            [attr.aria-expanded]="(menuService.menuState$ | async) ? 'true' : 'false'"
            [attr.aria-controls]="
                (menuService.menuState$ | async) ? 'sliding-menu' : null
            ">
            <div class="bar1"></div>
            <div class="bar2"></div>
            <div class="bar3"></div>
        </div>
        <div
            id="sliding-menu"
            class="sliding-menu"
            *ngIf="menuService.menuState$ | async"
            [class.change]="menuService.menuState$ | async">
            <!-- <div class="sliding-menu-header">
                <div class="submenu-hamburger">
                    <div class="bar1"></div>
                    <div class="bar2"></div>
                    <div class="bar3"></div>
                </div>
                <h2 class="menu-heading app-c-heading--h2--bold">Menu</h2>
            </div> -->
            <button
                type="button"
                class="close_sidemenu"
                [attr.aria-label]="'a11y.closeMenu' | translate"
                [title]="'a11y.closeMenu' | translate"
                (click)="closeToggleMenu()">
                <svg-icon icon="close" class="w-100 h-100"></svg-icon>
            </button>
            <div class="slide-menu-content">
                <div class="menu-item-details">
                    <h2 class="app-c-heading--h2--bold" translate>
                        topNav.aboutMe
                    </h2>
                    <div
                        tabindex="0"
                        role="button"
                        class="menu-items-details-container"
                        (click)="hamburgerMenuNav('/app/my-settings')"
                        (keypress)="hamburgerMenuNav('/app/my-settings')">
                        <div class="menu-items-first-section">
                            <svg-icon
                                icon="my-profile-icon"></svg-icon>
                            <p class="app-c-heading--h5" translate>
                                topNav.myProfile
                            </p>
                        </div>
                        <div class="menu-items-second-section">
                            <svg-icon
                                icon="right-arrow-circle"></svg-icon>
                        </div>
                    </div>
                    <!-- <div class="menu-items-details-container">
						<div class="menu-items-first-section">
							<svg-icon icon="my-association-icon"></svg-icon>
							<p class="app-c-heading--h5">My Associations</p>
						</div>
						<div class="menu-items-second-section">
							<svg-icon icon="right-arrow-circle"></svg-icon>
						</div>
					</div> -->
                    <div
                        tabindex="0"
                        role="button"
                        class="menu-items-details-container"
                        (click)="hamburgerMenuNav('/app/resources')"
                        (keypress)="hamburgerMenuNav('/app/resources')">
                        <div class="menu-items-first-section">
                            <svg-icon
                                icon="my-resources-icon"></svg-icon>
                            <p class="app-c-heading--h5" translate>
                                topNav.myResources
                            </p>
                        </div>
                        <div class="menu-items-second-section">
                            <svg-icon
                                icon="right-arrow-circle"></svg-icon>
                        </div>
                    </div>
                    <div
                        tabindex="0"
                        role="button"
                        class="menu-items-details-container"
                        (click)="hamburgerMenuNav('/app/my-data')"
                        (keypress)="hamburgerMenuNav('/app/my-data')">
                        <div class="menu-items-first-section">
                            <svg-icon
                                icon="my-data-icon"></svg-icon>
                            <p class="app-c-heading--h5" translate>
                                topNav.myData
                            </p>
                        </div>
                        <div class="menu-items-second-section">
                            <svg-icon
                                icon="right-arrow-circle"></svg-icon>
                        </div>
                    </div>
                </div>
                <div class="menu-item-details">
                    <h2 class="app-c-heading--h2--bold" translate>
                        topNav.support
                    </h2>
                    <div
                        tabindex="0"
                        role="button"
                        class="menu-items-details-container"
                        (click)="support()"
                        (keypress)="support()">
                        <div class="menu-items-first-section">
                            <svg-icon
                                icon="technical-support-icon"></svg-icon>
                            <p class="app-c-heading--h5" translate>
                                topNav.contactTechnicalSupport
                            </p>
                        </div>
                        <div class="menu-items-second-section">
                            <svg-icon
                                icon="right-arrow-circle"></svg-icon>
                        </div>
                    </div>
                    <div
                        tabindex="0"
                        role="button"
                        class="menu-items-details-container"
                        (click)="hamburgerMenuNav('/app/counselor-sync')"
                        (keypress)="hamburgerMenuNav('/app/counselor-sync')">
                        <div class="menu-items-first-section">
                            <svg-icon
                                icon="councellor-icon"></svg-icon>
                            <p class="app-c-heading--h5" translate>
                                topNav.syncWithCounselor{{ customOrgTextKey }}
                            </p>
                        </div>
                        <div class="menu-items-second-section">
                            <svg-icon
                                icon="right-arrow-circle"></svg-icon>
                        </div>
                    </div>
                </div>
                <div
                    class="menu-item-details mb-0"
                    *ngIf="user.userType === 'user'">
                    <h2 class="app-c-heading--h2--bold" translate>
                        topNav.userSurveys
                    </h2>
                    <div
                        tabindex="0"
                        role="button"
                        class="menu-items-details-container"
                        (click)="
                            hamburgerMenuNav(
                                '/app/surveys/' +
                                    user.userFeedbackSurveyId +
                                    '/UserFeedbackSurvey'
                            )
                        "
                        (keypress)="
                            hamburgerMenuNav(
                                '/app/surveys/' +
                                    user.userFeedbackSurveyId +
                                    '/UserFeedbackSurvey'
                            )
                        ">
                        <div class="menu-items-first-section">
                            <svg-icon
                                icon="feedback-survey-icon"></svg-icon>
                            <p class="app-c-heading--h5" translate>
                                topNav.dynamicTitleUserFeedbackSurvey
                            </p>
                        </div>
                        <div class="menu-items-second-section">
                            <svg-icon
                                icon="right-arrow-circle"></svg-icon>
                        </div>
                    </div>
                    <div
                        tabindex="0"
                        role="button"
                        class="menu-items-details-container"
                        (click)="
                            hamburgerMenuNav(
                                '/app/surveys/' +
                                    user.npsSurveyId +
                                    '/npsSurvey'
                            )
                        "
                        (keypress)="
                            hamburgerMenuNav(
                                '/app/surveys/' +
                                    user.npsSurveyId +
                                    '/npsSurvey'
                            )
                        ">
                        <div class="menu-items-first-section">
                            <svg-icon
                                icon="nps-survey-icon"></svg-icon>
                            <p class="app-c-heading--h5" translate>
                                topNav.npsSurvey
                            </p>
                        </div>
                        <div class="menu-items-second-section">
                            <svg-icon
                                icon="right-arrow-circle"></svg-icon>
                        </div>
                    </div>
                </div>
                <div class="menu-item-details mb-0">
                    <h2 class="app-c-heading--h2--bold" translate>
                        topNav.settings
                    </h2>
                    <div
                        *ngIf="user.userType == 'user'"
                        tabindex="0"
                        class="menu-items-details-container"
                        (click)="subMenuToggle('moodcheck')"
                        (keypress)="subMenuToggle('moodcheck')">
                        <div class="menu-items-first-section">
                            <svg-icon
                                icon="moodcheck-reminder-icon"></svg-icon>
                            <p class="app-c-heading--h5" translate>
                                topNav.moodcheckReminders
                            </p>
                        </div>
                        <div class="menu-items-second-section">
                            <svg-icon
                                icon="right-arrow-circle"></svg-icon>
                        </div>
                    </div>
                    <!-- <div class="menu-items-details-container">
						<div class="menu-items-first-section">
							<svg-icon icon="fun-achievement-icon"></svg-icon>
							<p class="app-c-heading--h5">
								Fun & Achievement Reminders
							</p>
						</div>
						<div class="menu-items-second-section">
							<svg-icon icon="right-arrow-circle"></svg-icon>
						</div>
					</div> -->
                    <div
                        tabindex="0"
                        role="button"
                        class="menu-items-details-container"
                        (click)="subMenuToggle('language')"
                        (keypress)="subMenuToggle('language')">
                        <div class="menu-items-first-section">
                            <svg-icon
                                icon="language-selection-icon"></svg-icon>
                            <p class="app-c-heading--h5" translate>
                                topNav.languageSelection
                            </p>
                        </div>
                        <div class="menu-items-second-section">
                            <svg-icon
                                icon="right-arrow-circle"></svg-icon>
                        </div>
                    </div>
                </div>
                <nav
                    id="nav"
                    role="navigation"
                    class="navigation-section first-navigation-section hamburger-side-bar"
                    [class.change]="menuService.menuState$ | async">
                    <div class="menu-items">
                        <ng-container *ngFor="let menu of menuList">
                            <ng-container *accessControl="menu.accessControl">
                                <div
                                    *ngIf="
                                        customCondition(menu) &&
                                        !(
                                            [
                                                'image',
                                                'profilelogo',
                                                'button',
                                            ].includes(menu.type) ||
                                            ['image', 'profilelogo'].includes(
                                                menu.menu
                                            )
                                        )
                                    "
                                    class="menu-items-details"
                                    tabindex="0">
                                    <div class="menu-list">
                                        <!--Dynamic Menu  -->
                                        <div
                                            *ngIf="
                                                menu.type === 'dynamic';
                                                and: user.userType === 'user'
                                            ">
                                            <div
                                                class="menu-item"
                                                [class.active]="
                                                    isActive(menu.path)
                                                ">
                                                <a
                                                    [routerLink]="menu.path"
                                                    class="menu-link">
                                                    <img
                                                        [src]="
                                                            menu.imageIcon.src
                                                        "
                                                        [alt]="
                                                            menu.imageIcon.alt
                                                        "
                                                        [class]="
                                                            menu.imageIcon.class
                                                        "
                                                        [name]="
                                                            menu.imageIcon.name
                                                        " />
                                                    <span class="menu-text">{{
                                                        menu.menu | translate
                                                    }}</span>
                                                </a>
                                            </div>
                                        </div>
                                        <!--BUTTON-->
                                        <div
                                            *ngIf="
                                                menu.type === 'btn-dropdown' &&
                                                showOrgdropdown &&
                                                (user.userType == 'orgadmin' ||
                                                    user.userType ==
                                                        'professional')
                                            "
                                            class="org-menu">
                                            <organization-dropdown></organization-dropdown>
                                        </div>
                                        <!--LABEL-->
                                        <div
                                            class="app-l-menu__over"
                                            *ngIf="
                                                menu.subMenu.length == '0' &&
                                                menu.type == 'label'
                                            "
                                            (click)="menuService.nav(menu.path)"
                                            (keypress)="
                                                menuService.nav(menu.path)
                                            "
                                            tabindex="0"
                                            [title]="menu.menu | translate"
                                            role="menuitem">
                                            <span
                                                class="app-l-menu__icon"
                                                [attr.aria-label]="menu.menu | translate">
                                                <svg-icon
                                                    [icon]="menu.name"
                                                    class="w-100 h-100"
                                                    [alt]="null"></svg-icon>
                                            </span>
                                            <div
                                                *ngIf="
                                                    newBadgeCount$
                                                        | async as badgeCount
                                                ">
                                                <div
                                                    class="badge-count"
                                                    *ngIf="badgeCount > 0">
                                                    {{ badgeCount }}
                                                </div>
                                            </div>
                                            <span
                                                class="app-l-menu__label"
                                                translate
                                                >{{ menu.menu }}</span
                                            >
                                        </div>
                                        <!--Dropdown Menus-->
                                        <div
                                            class="dropdown menu-submenu-title tools-dropdown"
                                            [attr.data-submenu-for]="menu.id + '-' + menu.name"
                                            [attr.aria-haspopup]="'true'"
                                            [attr.aria-expanded]="menu.showSubMenu ? 'true' : 'false'"
                                            (click)="toggleSubMenu(menu)"
                                            (keypress)="$event.target === $event.currentTarget ? toggleSubMenu(menu) : null"
                                            *ngIf="
                                                menu.subMenu.length > '0' &&
                                                menu.menu != 'profilelogo'
                                            "
                                            [ngClass]="{
                                                active: menu.showSubMenu,
                                            }"
                                            (click)="goTo(menu.path)"
                                            [title]="menu.menu | translate"
                                            (keypress)="$event.target === $event.currentTarget ? goTo(menu.path) : null">
                                            <!-- [ngClass]="getDynamicClasses(menu,menu.imageIcon.alt)" -->
                                            <div
                                                class="app-l-menu__over contains_submenu"
                                                [ngClass]="{
                                                    active: menu.showSubMenu,
                                                }">
                                                <span
                                                    class="app-l-menu__icon"
                                                    [attr.aria-label]="menu.menu | translate">
                                                    <svg-icon
                                                        [icon]="menu.name"
                                                        class="w-100 h-100"
                                                        [alt]="null"></svg-icon>
                                                </span>
                                                <span
                                                    class="app-l-menu__label"
                                                    *ngIf="
                                                        menu.type == 'label'
                                                    ">
                                                    <a
                                                        tabindex="0"
                                                        class="menu.class labels-style"
                                                        routerLinkActive="active"
                                                        [routerLinkActiveOptions]="{
                                                            exact:
                                                                menu.imageIcon
                                                                    .alt ===
                                                                'Dashboard'
                                                                    ? true
                                                                    : false,
                                                        }"
                                                        (click)="
                                                            menuService.nav(
                                                                menu.path
                                                            )
                                                        "
                                                        (keypress)="
                                                            menuService.nav(
                                                                menu.path
                                                            )
                                                        ">
                                                        <span translate>{{
                                                            menu.menu
                                                        }}</span>
                                                    </a>
                                                </span>
                                                <span
                                                    *ngIf="
                                                        menu.type == 'image'
                                                    ">
                                                    <img
                                                        [alt]="
                                                            menu.imageIcon.alt
                                                        "
                                                        [class]="
                                                            menu.imageIcon.class
                                                        "
                                                        [src]="
                                                            menu.imageIcon.src
                                                        "
                                                        style="height: 20px" />
                                                </span>
                                                <button
                                                    class="dropbtn"
                                                    [attr.aria-label]="(menu.menu | translate) + ' ' + ('a11y.submenu' | translate)"
                                                    [ngClass]="{
                                                        collapsed:
                                                            isCollapsed[
                                                                menu.name
                                                            ],
                                                    }"
                                                    (click)="
                                                        toggleCollapse(
                                                            menu.name
                                                        )
                                                    "
                                                    attr.aria-expanded="{{
                                                        isCollapsed[menu.name]
                                                    }}">
                                                    <svg-icon
                                                        icon="angle-down"
                                                        class="w-100 h-100"></svg-icon>
                                                </button>
                                            </div>
                                            <div
                                                class="submenu-container"
                                                [ngClass]="{
                                                    show: menu.showSubMenu,
                                                }">
                                                <div
                                                    class="dropdown-content"
                                                    [ngClass]="{
                                                        show: menu.showSubMenu,
                                                    }"
                                                    *ngFor="
                                                        let submenu of menu.subMenu
                                                    ">
                                                    <div
                                                        *ngIf="
                                                            customCondition(
                                                                submenu
                                                            )
                                                        ">
                                                        <ng-container
                                                            *accessControl="
                                                                submenu.accessControl
                                                            ">
                                                            <a
                                                                tabindex="0"
                                                                [ngClass]="
                                                                    submenu.class
                                                                "
                                                                class="dropdown-item"
                                                                *ngIf="
                                                                    submenu
                                                                        .subMenu
                                                                        .length ==
                                                                    '0'
                                                                "
                                                                [alt]="
                                                                    getDynamicClasses(
                                                                        submenu,
                                                                        submenu
                                                                            .imageIcon
                                                                            .alt
                                                                    )
                                                                "
                                                                routerLinkActive="active"
                                                                [routerLinkActiveOptions]="{
                                                                    exact:
                                                                        submenu
                                                                            .imageIcon
                                                                            .alt ===
                                                                        'Dashboard'
                                                                            ? true
                                                                            : false,
                                                                }"
                                                                (click)="
                                                                    submenu.outputType ==
                                                                    'popup'
                                                                        ? modalFunction(
                                                                              submenu.accessControl
                                                                          )
                                                                        : menuService.nav(
                                                                              submenu.path
                                                                          )
                                                                "
                                                                (keypress)="
                                                                    submenu.outputType ==
                                                                    'popup'
                                                                        ? modalFunction(
                                                                              submenu.accessControl
                                                                          )
                                                                        : menuService.nav(
                                                                              submenu.path
                                                                          )
                                                                ">
                                                                <span
                                                                    class="app-l-menu__icon"
                                                                    (click)="
                                                                        goTo(
                                                                            submenu.path
                                                                        )
                                                                    "
                                                                    (keypress)="
                                                                        goTo(
                                                                            submenu.path
                                                                        )
                                                                    "
                                                                    [attr.aria-label]="submenu.menu | translate">
                                                                    <svg-icon
                                                                        [icon]="
                                                                            submenu
                                                                                .imageIcon
                                                                                .name
                                                                        "
                                                                        class="w-100 h-100"
                                                                        [alt]="null"></svg-icon>
                                                                    <!-- <img [alt]="menu.imageIcon.alt" class="menu.imageIcon.class"
                                                        [src]="submenu.imageIcon.src" /> -->
                                                                </span>
                                                                <span
                                                                    class="submenu-title"
                                                                    translate>
                                                                    {{
                                                                        submenu.menu
                                                                    }}
                                                                </span>
                                                            </a>
                                                            <div
                                                                class="second-dropdown menu-submenu-title sub-dropdown-section"
                                                                *ngIf="
                                                                    submenu
                                                                        .subMenu
                                                                        .length >
                                                                    '0'
                                                                "
                                                                (click)="
                                                                    toggleSecondSubMenu(
                                                                        submenu,
                                                                        menu
                                                                    )
                                                                "
                                                                (keypress)="
                                                                    toggleSecondSubMenu(
                                                                        submenu,
                                                                        menu
                                                                    )
                                                                ">
                                                                <div
                                                                    class="app-l-menu__over">
                                                                    <span
                                                                        *ngIf="
                                                                            submenu.type ==
                                                                            'label'
                                                                        "
                                                                        translate>
                                                                        <a
                                                                            tabindex="0"
                                                                            class="submenu.class"
                                                                            [ngClass]="
                                                                                getDynamicClasses(
                                                                                    submenu,
                                                                                    submenu
                                                                                        .imageIcon
                                                                                        .alt
                                                                                )
                                                                            "
                                                                            routerLinkActive="active"
                                                                            [routerLinkActiveOptions]="{
                                                                                exact:
                                                                                    submenu
                                                                                        .imageIcon
                                                                                        .alt ===
                                                                                    'Dashboard'
                                                                                        ? true
                                                                                        : false,
                                                                            }"
                                                                            (click)="
                                                                                submenu.outputType ==
                                                                                'popup'
                                                                                    ? modalFunction(
                                                                                          submenu.accessControl
                                                                                      )
                                                                                    : menuService.nav(
                                                                                          submenu.path
                                                                                      )
                                                                            "
                                                                            (keypress)="
                                                                                submenu.outputType ==
                                                                                'popup'
                                                                                    ? modalFunction(
                                                                                          submenu.accessControl
                                                                                      )
                                                                                    : menuService.nav(
                                                                                          submenu.path
                                                                                      )
                                                                            ">
                                                                            <span
                                                                                class="app-l-menu__icon"
                                                                                (click)="
                                                                                    goTo(
                                                                                        submenu.path
                                                                                    )
                                                                                "
                                                                                (keypress)="
                                                                                    goTo(
                                                                                        submenu.path
                                                                                    )
                                                                                "
                                                                                [attr.aria-label]="submenu.menu | translate">
                                                                                <!-- <img [alt]="menu.imageIcon.alt"
                                                                            class="menu.imageIcon.class"
                                                                            [src]="submenu.imageIcon.src"
                                                                            style="height: 20px" /> -->
                                                                                <svg-icon
                                                                                    [icon]="
                                                                                        submenu
                                                                                            .imageIcon
                                                                                            .name
                                                                                    "
                                                                                    [alt]="null"
                                                                                    class="w-100 h-100"></svg-icon>
                                                                            </span>
                                                                            <span
                                                                                class="submenu-title"
                                                                                translate>
                                                                                {{
                                                                                    submenu.menu
                                                                                }}
                                                                            </span>
                                                                        </a>
                                                                    </span>
                                                                    <span
                                                                        *ngIf="
                                                                            submenu.type ==
                                                                            'image'
                                                                        ">
                                                                        <img
                                                                            [alt]="
                                                                                submenu
                                                                                    .imageIcon
                                                                                    .alt
                                                                            "
                                                                            class="submenu.imageIcon.class"
                                                                            [src]="
                                                                                submenu
                                                                                    .imageIcon
                                                                                    .src
                                                                            "
                                                                            style="
                                                                                height: 20px;
                                                                            "
                                                                    /></span>
                                                                    <button
                                                                        class="dropbtn"
                                                                        [attr.aria-label]="(submenu.menu | translate) + ' ' + ('a11y.submenu' | translate)"
                                                                        [ngClass]="{
                                                                            collapsed:
                                                                                isCollapsed[
                                                                                    submenu
                                                                                        .name
                                                                                ],
                                                                        }"
                                                                        (click)="
                                                                            toggleCollapse(
                                                                                submenu.name
                                                                            )
                                                                        "
                                                                        attr.aria-expanded="{{
                                                                            isCollapsed[
                                                                                submenu
                                                                                    .name
                                                                            ]
                                                                        }}">
                                                                        <!-- <i class="fa fa-caret-down"></i> -->
                                                                        <svg-icon
                                                                            icon="angle-right"
                                                                            class="w-100 h-100"
                                                                            alt="angle-right"
                                                                            title="angle-right"></svg-icon>
                                                                    </button>
                                                                </div>
                                                                <div
                                                                    class="second-submenu-container"
                                                                    [ngClass]="{
                                                                        show: submenu.showSecondSubMenu,
                                                                    }">
                                                                    <div
                                                                        class="second-dropdown-content dropdown-content"
                                                                        [ngClass]="{
                                                                            show: submenu.showSecondSubMenu,
                                                                        }"
                                                                        *ngFor="
                                                                            let innersubmenu of submenu.subMenu
                                                                        ">
                                                                        <div
                                                                            *ngIf="
                                                                                customCondition(
                                                                                    innersubmenu
                                                                                )
                                                                            ">
                                                                            <ng-container
                                                                                *accessControl="
                                                                                    innersubmenu.accessControl
                                                                                ">
                                                                                <a
                                                                                    translate
                                                                                    tabindex="0"
                                                                                    class="second-dropdown-item"
                                                                                    *ngIf="
                                                                                        innersubmenu
                                                                                            .subMenu
                                                                                            .length ==
                                                                                        '0'
                                                                                    "
                                                                                    [ngClass]="
                                                                                        getDynamicClasses(
                                                                                            innersubmenu,
                                                                                            innersubmenu
                                                                                                .imageIcon
                                                                                                .alt
                                                                                        )
                                                                                    "
                                                                                    routerLinkActive="active"
                                                                                    [routerLinkActiveOptions]="{
                                                                                        exact:
                                                                                            innersubmenu
                                                                                                .imageIcon
                                                                                                .alt ===
                                                                                            'Dashboard'
                                                                                                ? true
                                                                                                : false,
                                                                                    }"
                                                                                    (click)="
                                                                                        innersubmenu.outputType ==
                                                                                        'popup'
                                                                                            ? modalFunction(
                                                                                                  innersubmenu.accessControl
                                                                                              )
                                                                                            : menuService.nav(
                                                                                                  innersubmenu.path
                                                                                              )
                                                                                    "
                                                                                    (keypress)="
                                                                                        innersubmenu.outputType ==
                                                                                        'popup'
                                                                                            ? modalFunction(
                                                                                                  innersubmenu.accessControl
                                                                                              )
                                                                                            : menuService.nav(
                                                                                                  innersubmenu.path
                                                                                              )
                                                                                    ">
                                                                                    <span
                                                                                        class="app-l-menu__icon"
                                                                                        (click)="
                                                                                            goTo(
                                                                                                innersubmenu.path
                                                                                            )
                                                                                        "
                                                                                        (keypress)="
                                                                                            goTo(
                                                                                                innersubmenu.path
                                                                                            )
                                                                                        "
                                                                                        [attr.aria-label]="innersubmenu.menu | translate">
                                                                                        <!-- <img [alt]="menu.imageIcon.alt"
                                                                            class="menu.imageIcon.class"
                                                                            [src]="innersubmenu.imageIcon.src" /> -->
                                                                                        <svg-icon
                                                                                            [icon]="
                                                                                                innersubmenu
                                                                                                    .imageIcon
                                                                                                    .name
                                                                                            "
                                                                                            [alt]="null"
                                                                                            class="w-100 h-100"></svg-icon>
                                                                                    </span>
                                                                                    <span
                                                                                        class="innersubmenu-title submenu-title"
                                                                                        translate>
                                                                                        {{
                                                                                            innersubmenu.menu
                                                                                        }}
                                                                                    </span>
                                                                                </a>
                                                                            </ng-container>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </nav>
            </div>
            <div class="sliding-menu-footer">
                <button
                    class="sign-out-button"
                    type="button"
                    (click)="menuService.onLogout()"
                    translate>
                    <svg-icon icon="sign-out-button-icon"></svg-icon
                    >topNav.signOut
                </button>
                <svg-icon
                    icon="powered-by-logo"
                    class="footer-logo"
                    [alt]="'a11y.poweredBy' | translate"></svg-icon>
            </div>
            <div class="sliding-submenu" *ngIf="showSubMenu === 'moodcheckSub'">
                <div class="sliding-submenu-header">
                    <h2 class="app-c-heading--h2--bold" translate>
                        topNav.moodcheckReminders
                    </h2>
                    <button
                        (click)="showSubMenu = ''"
                        (keypress)="showSubMenu = ''">
                        <svg-icon
                            icon="close"
                            title="close"
                            alt="close"></svg-icon>
                    </button>
                </div>
                <div class="sliding-submenu-content">
                    <div class="content-header">
                        <h2 class="app-c-heading--h2--bold" translate>
                            topNav.moodcheckReminders
                        </h2>
                        <label class="switch">
                            <input type="checkbox" [(ngModel)]="reminders" />
                            <span class="slider round"></span>
                        </label>
                    </div>
                    <p class="submenu-content-text" translate>
                        topNav.moodPatterns
                    </p>
                    <div class="badges-container" tabindex="0">
                        <h3 translate>topNav.howManyTimes</h3>
                        <div class="badges-section">
                            <div
                                class="badge"
                                *ngFor="let item of [1, 2, 3, 4, 0]"
                                (click)="moodcheckFreq = item"
                                (keypress)="moodcheckFreq = item"
                                [ngClass]="{
                                    active: moodcheckFreq == item,
                                    'never-badge': item == 0,
                                    'btn-disabled': !reminders,
                                }"
                                translate>
                                {{ 'moodcheck.moodcheckFrequency.' + item }}
                            </div>
                        </div>
                    </div>
                    <div class="sliding-submenu-footer" tabindex="0">
                        <button
                            class="app-c-btn app-c-btn--primary app-c-btn--curve"
                            (click)="saveMoodcheckFrequencyModal()"
                            (keypress)="saveMoodcheckFrequencyModal()"
                            translate>
                            topNav.applyChanges
                        </button>
                    </div>
                </div>
            </div>
            <div class="sliding-submenu" *ngIf="showSubMenu === 'languageSub'">
                <div class="sliding-submenu-header">
                    <h2 class="app-c-heading--h2--bold" translate>
                        topNav.languageSelection
                    </h2>
                    <button
                        (click)="showSubMenu = ''"
                        (keypress)="showSubMenu = ''">
                        <svg-icon
                            icon="close"
                            title="close"
                            alt="close"></svg-icon>
                    </button>
                </div>
                <div class="sliding-submenu-content">
                    <div
                        class="language-selection-main-container"
                        role="radiogroup"
                        aria-label="Language Selection">
                        <div
                            *ngFor="let lang of languages"
                            class="language-selection-option"
                            tabindex="0"
                            role="radio"
                            [attr.aria-checked]="
                                language === lang.value ? 'true' : 'false'
                            "
                            (keydown)="handleKeydown($event, lang.value)"
                            (click)="selectLanguage(lang.value)">
                            <label>
                                <input
                                    type="radio"
                                    class="question-option"
                                    tabindex="-1"
                                    name="100"
                                    [value]="lang.value"
                                    [(ngModel)]="language" />
                                <div class="app-c-custom__select">
                                    <div class="language-content">
                                        <svg-icon [icon]="lang.icon"></svg-icon>
                                        <span
                                            class="app-c-custom__select-text"
                                            >{{ lang.label | translate }}</span
                                        >
                                    </div>
                                    <svg-icon
                                        icon="tick-circle"
                                        class="app-c-custom__select-icon">
                                        <svg>
                                            <use
                                                xlink:href="../../../assets/icon/svg-icon-def.svg#tick-circle"></use>
                                        </svg>
                                    </svg-icon>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div class="sliding-submenu-footer">
                        <button
                            class="app-c-btn app-c-btn--primary app-c-btn--curve"
                            (click)="saveLanguageData(language)"
                            (keypress)="handleKeydownForButton($event)">
                            Apply Changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay-sidemenu"></div>

        <div class="app-l-logo">
            <h1 tabindex="0">
                <a class="header-logo" alt="Welltrack boost" routerLink="/app">
                    <svg-icon
                        icon="logo"
                        class="w-100 h-100"
                        title="Welltrack boost"></svg-icon>
                </a>
            </h1>
        </div>
    </div>
    <div class="navigation-items">
        <nav
            id="nav"
            role="navigation"
            class="navigation-section first-navigation-section hamburger-side-bar"
            [class.change]="menuService.menuState$ | async">
            <div class="menu-items">
                <ng-container *ngFor="let menu of menuList">
                    <ng-container *accessControl="menu.accessControl">
                        <div
                            *ngIf="
                                customCondition(menu) &&
                                !(
                                    ['image', 'profilelogo', 'button'].includes(
                                        menu.type
                                    ) ||
                                    ['image', 'profilelogo'].includes(menu.menu)
                                )
                            "
                            class="menu-items-details">
                            <div class="menu-list">
                                <!--Dynamic Menu  -->
                                <div
                                    class="app-l-menu__over"
                                    *ngIf="
                                        menu.type === 'dynamic' &&
                                        user.userType === 'user'
                                    "
                                    (click)="menuService.nav(menu.path)"
                                    (keypress)="menuService.nav(menu.path)"
                                    tabindex="0"
                                    [attr.aria-label]="menu.menu | translate"
                                    [title]="menu.menu | translate"
                                    role="menuitem">
                                    <span class="app-l-menu__icon">
                                        <img
                                            [src]="
                                                menu.imageIcon.src ||
                                                menu.imageIcon.dynamicSrc
                                            "
                                            [alt]="menu.imageIcon.alt"
                                            [class]="menu.imageIcon.class"
                                            [name]="menu.imageIcon.name" />
                                    </span>
                                </div>
                                <!--BUTTON-->
                                <div
                                    *ngIf="
                                        menu.type === 'btn-dropdown' &&
                                        (user.userType == 'orgadmin' ||
                                            user.userType == 'professional')
                                    "
                                    class="org-menu">
                                    <organization-dropdown></organization-dropdown>
                                </div>
                                <!--LABEL-->
                                <div
                                    class="app-l-menu__over"
                                    *ngIf="
                                        menu.subMenu.length == '0' &&
                                        menu.type == 'label'
                                    "
                                    role="menuitem"
                                    tabindex="0"
                                    (click)="menuService.nav(menu.path)"
                                    (keypress)="menuService.nav(menu.path)"
                                    [attr.aria-label]="menu.menu | translate"
                                    [title]="menu.menu | translate">
                                    <span class="app-l-menu__icon">
                                        <svg-icon
                                            [icon]="menu.name"
                                            class="w-100 h-100"
                                            [alt]="null"></svg-icon>
                                    </span>

                                    <div
                                        class="badge-count"
                                        *ngIf="
                                            menu.name === 'badge' &&
                                            newBadgesCount > 0
                                        ">
                                        {{ newBadgesCount }}
                                    </div>

                                    <span class="app-l-menu__label">
                                        <span
                                            class="labels-style non-drp-down"
                                            translate>
                                            {{ menu.menu }}
                                        </span>
                                    </span>
                                </div>
                                <!--Dropdown Menus-->
                                <div
                                    class="dropdown menu-submenu-title tools-dropdown"
                                            [attr.data-submenu-for]="menu.id + '-' + menu.name"
                                            [attr.aria-haspopup]="'true'"
                                            [attr.aria-expanded]="menu.showSubMenu ? 'true' : 'false'"
                                    (click)="toggleSubMenu(menu)"
                                    (keypress)="$event.target === $event.currentTarget ? toggleSubMenu(menu) : null"
                                    *ngIf="
                                        menu.subMenu.length > '0' &&
                                        menu.menu != 'profilelogo'
                                    "
                                    tabindex="0"
                                    [title]="menu.menu | translate"
                                    role="menuitem"
                                    [ngClass]="{ active: menu.showSubMenu }"
                                    (click)="goTo(menu.path)"
                                    (keypress)="$event.target === $event.currentTarget ? goTo(menu.path) : null">
                                    <!-- [ngClass]="getDynamicClasses(menu,menu.imageIcon.alt)" -->
                                    <div
                                        class="app-l-menu__over contains_submenu"
                                        [ngClass]="{
                                            active: menu.showSubMenu,
                                        }">
                                        <span
                                            class="app-l-menu__icon"
                                            [attr.aria-label]="menu.menu | translate">
                                            <svg-icon
                                                [icon]="menu.name"
                                                class="w-100 h-100"
                                                [alt]="null"></svg-icon>
                                        </span>
                                        <span
                                            class="app-l-menu__label"
                                            *ngIf="menu.type == 'label'">
                                            <a
                                                tabindex="0"
                                                class="menu.class labels-style"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact:
                                                        menu.imageIcon.alt ===
                                                        'Dashboard'
                                                            ? true
                                                            : false,
                                                }"
                                                (click)="
                                                    menuService.nav(menu.path)
                                                "
                                                (keypress)="
                                                    menuService.nav(menu.path)
                                                ">
                                                <span translate>{{
                                                    menu.menu
                                                }}</span>
                                            </a>
                                        </span>
                                        <span *ngIf="menu.type == 'image'">
                                            <img
                                                [alt]="menu.imageIcon.alt"
                                                [class]="menu.imageIcon.class"
                                                [src]="menu.imageIcon.src"
                                                style="height: 20px" />
                                        </span>
                                        <button
                                            class="dropbtn"
                                            [attr.aria-label]="(menu.menu | translate) + ' ' + ('a11y.submenu' | translate)"
                                            [ngClass]="{
                                                collapsed:
                                                    isCollapsed[menu.name],
                                            }"
                                            (click)="toggleCollapse(menu.name)"
                                            attr.aria-expanded="{{
                                                isCollapsed[menu.name]
                                            }}">
                                            <svg-icon
                                                icon="angle-down"
                                                class="w-100 h-100"></svg-icon>
                                        </button>
                                    </div>
                                    <div
                                        class="submenu-container"
                                        [ngClass]="{ show: menu.showSubMenu }">
                                        <div
                                            class="dropdown-content"
                                            [ngClass]="{
                                                show: menu.showSubMenu,
                                            }"
                                            *ngFor="
                                                let submenu of menu.subMenu
                                            ">
                                            <div
                                                *ngIf="
                                                    customCondition(submenu)
                                                ">
                                                <ng-container
                                                    *accessControl="
                                                        submenu.accessControl
                                                    ">
                                                    <a
                                                        tabindex="0"
                                                        [ngClass]="
                                                            submenu.class
                                                        "
                                                        class="dropdown-item"
                                                        *ngIf="
                                                            submenu.subMenu
                                                                .length == '0'
                                                        "
                                                        [alt]="
                                                            getDynamicClasses(
                                                                submenu,
                                                                submenu
                                                                    .imageIcon
                                                                    .alt
                                                            )
                                                        "
                                                        routerLinkActive="active"
                                                        [routerLinkActiveOptions]="{
                                                            exact:
                                                                submenu
                                                                    .imageIcon
                                                                    .alt ===
                                                                'Dashboard'
                                                                    ? true
                                                                    : false,
                                                        }"
                                                        (click)="
                                                            submenu.outputType ==
                                                            'popup'
                                                                ? modalFunction(
                                                                      submenu.accessControl
                                                                  )
                                                                : menuService.nav(
                                                                      submenu.path
                                                                  )
                                                        "
                                                        (keypress)="
                                                            submenu.outputType ==
                                                            'popup'
                                                                ? modalFunction(
                                                                      submenu.accessControl
                                                                  )
                                                                : menuService.nav(
                                                                      submenu.path
                                                                  )
                                                        ">
                                                        <span
                                                            class="app-l-menu__icon"
                                                            (click)="
                                                                goTo(
                                                                    submenu.path
                                                                )
                                                            "
                                                            (keypress)="
                                                                goTo(
                                                                    submenu.path
                                                                )
                                                            "
                                                            [attr.aria-label]="submenu.menu | translate">
                                                            <svg-icon
                                                                [icon]="
                                                                    submenu
                                                                        .imageIcon
                                                                        .name
                                                                "
                                                                class="w-100 h-100"
                                                                [alt]="null"></svg-icon>
                                                            <!-- <img [alt]="menu.imageIcon.alt" class="menu.imageIcon.class"
                                                        [src]="submenu.imageIcon.src" /> -->
                                                        </span>
                                                        <span
                                                            class="submenu-title"
                                                            translate>
                                                            {{ submenu.menu }}
                                                        </span>
                                                    </a>
                                                    <div
                                                        class="second-dropdown menu-submenu-title sub-dropdown-section"
                                                        *ngIf="
                                                            submenu.subMenu
                                                                .length > '0'
                                                        "
                                                        (click)="
                                                            toggleSecondSubMenu(
                                                                submenu,
                                                                menu
                                                            )
                                                        "
                                                        (keypress)="
                                                            toggleSecondSubMenu(
                                                                submenu,
                                                                menu
                                                            )
                                                        ">
                                                        <div
                                                            class="app-l-menu__over">
                                                            <span
                                                                *ngIf="
                                                                    submenu.type ==
                                                                    'label'
                                                                "
                                                                translate>
                                                                <a
                                                                    tabindex="0"
                                                                    class="dropdown-item"
                                                                    [ngClass]="
                                                                        getDynamicClasses(
                                                                            submenu,
                                                                            submenu
                                                                                .imageIcon
                                                                                .alt
                                                                        )
                                                                    "
                                                                    routerLinkActive="active"
                                                                    [routerLinkActiveOptions]="{
                                                                        exact:
                                                                            submenu
                                                                                .imageIcon
                                                                                .alt ===
                                                                            'Dashboard'
                                                                                ? true
                                                                                : false,
                                                                    }"
                                                                    (click)="
                                                                        submenu.outputType ==
                                                                        'popup'
                                                                            ? modalFunction(
                                                                                  submenu.accessControl
                                                                              )
                                                                            : menuService.nav(
                                                                                  submenu.path
                                                                              )
                                                                    "
                                                                    (keypress)="
                                                                        submenu.outputType ==
                                                                        'popup'
                                                                            ? modalFunction(
                                                                                  submenu.accessControl
                                                                              )
                                                                            : menuService.nav(
                                                                                  submenu.path
                                                                              )
                                                                    ">
                                                                    <span
                                                                        class="app-l-menu__icon"
                                                                        (click)="
                                                                            goTo(
                                                                                submenu.path
                                                                            )
                                                                        "
                                                                        (keypress)="
                                                                            goTo(
                                                                                submenu.path
                                                                            )
                                                                        "
                                                                        [attr.aria-label]="submenu.menu | translate">
                                                                        <!-- <img [alt]="menu.imageIcon.alt"
                                                                        class="menu.imageIcon.class"
                                                                        [src]="submenu.imageIcon.src"
                                                                        style="height: 20px" /> -->
                                                                        <svg-icon
                                                                            [icon]="
                                                                                submenu
                                                                                    .imageIcon
                                                                                    .name
                                                                            "
                                                                            [alt]="null"
                                                                            class="w-100 h-100"></svg-icon>
                                                                    </span>
                                                                    <span
                                                                        class="submenu-title"
                                                                        translate>
                                                                        {{
                                                                            submenu.menu
                                                                        }}
                                                                    </span>
                                                                </a>
                                                            </span>
                                                            <span
                                                                *ngIf="
                                                                    submenu.type ==
                                                                    'image'
                                                                ">
                                                                <img
                                                                    [alt]="
                                                                        submenu
                                                                            .imageIcon
                                                                            .alt
                                                                    "
                                                                    class="submenu.imageIcon.class"
                                                                    [src]="
                                                                        submenu
                                                                            .imageIcon
                                                                            .src
                                                                    "
                                                                    style="
                                                                        height: 20px;
                                                                    "
                                                            /></span>
                                                            <button
                                                                class="dropbtn"
                                                                [attr.aria-label]="(submenu.menu | translate) + ' ' + ('a11y.submenu' | translate)"
                                                                [ngClass]="{
                                                                    collapsed:
                                                                        isCollapsed[
                                                                            submenu
                                                                                .name
                                                                        ],
                                                                }"
                                                                (click)="
                                                                    toggleCollapse(
                                                                        submenu.name
                                                                    )
                                                                "
                                                                attr.aria-expanded="{{
                                                                    isCollapsed[
                                                                        submenu
                                                                            .name
                                                                    ]
                                                                }}">
                                                                <!-- <i class="fa fa-caret-down"></i> -->
                                                                <svg-icon
                                                                    icon="angle-right"
                                                                    class="w-100 h-100"
                                                                    alt="angle-right"
                                                                    title="angle-right"></svg-icon>
                                                            </button>
                                                        </div>
                                                        <div
                                                            class="second-submenu-container"
                                                            [ngClass]="{
                                                                show: submenu.showSecondSubMenu,
                                                            }">
                                                            <div
                                                                class="second-dropdown-content dropdown-content"
                                                                [ngClass]="{
                                                                    show: submenu.showSecondSubMenu,
                                                                }"
                                                                *ngFor="
                                                                    let innersubmenu of submenu.subMenu
                                                                ">
                                                                <div
                                                                    *ngIf="
                                                                        customCondition(
                                                                            innersubmenu
                                                                        )
                                                                    ">
                                                                    <ng-container
                                                                        *accessControl="
                                                                            innersubmenu.accessControl
                                                                        ">
                                                                        <a
                                                                            translate
                                                                            tabindex="0"
                                                                            class="second-dropdown-item"
                                                                            *ngIf="
                                                                                innersubmenu
                                                                                    .subMenu
                                                                                    .length ==
                                                                                '0'
                                                                            "
                                                                            [ngClass]="
                                                                                getDynamicClasses(
                                                                                    innersubmenu,
                                                                                    innersubmenu
                                                                                        .imageIcon
                                                                                        .alt
                                                                                )
                                                                            "
                                                                            routerLinkActive="active"
                                                                            [routerLinkActiveOptions]="{
                                                                                exact:
                                                                                    innersubmenu
                                                                                        .imageIcon
                                                                                        .alt ===
                                                                                    'Dashboard'
                                                                                        ? true
                                                                                        : false,
                                                                            }"
                                                                            (click)="
                                                                                innersubmenu.outputType ==
                                                                                'popup'
                                                                                    ? modalFunction(
                                                                                          innersubmenu.accessControl
                                                                                      )
                                                                                    : menuService.nav(
                                                                                          innersubmenu.path
                                                                                      )
                                                                            "
                                                                            (keypress)="
                                                                                innersubmenu.outputType ==
                                                                                'popup'
                                                                                    ? modalFunction(
                                                                                          innersubmenu.accessControl
                                                                                      )
                                                                                    : menuService.nav(
                                                                                          innersubmenu.path
                                                                                      )
                                                                            ">
                                                                            <span
                                                                                class="app-l-menu__icon"
                                                                                (click)="
                                                                                    goTo(
                                                                                        innersubmenu.path
                                                                                    )
                                                                                "
                                                                                (keypress)="
                                                                                    goTo(
                                                                                        innersubmenu.path
                                                                                    )
                                                                                "
                                                                                [attr.aria-label]="innersubmenu.menu | translate">
                                                                                <!-- <img [alt]="menu.imageIcon.alt"
                                                                            class="menu.imageIcon.class"
                                                                            [src]="innersubmenu.imageIcon.src" /> -->
                                                                                <svg-icon
                                                                                    [icon]="
                                                                                        innersubmenu
                                                                                            .imageIcon
                                                                                            .name
                                                                                    "
                                                                                    [alt]="null"
                                                                                    class="w-100 h-100"></svg-icon>
                                                                            </span>
                                                                            <span
                                                                                class="innersubmenu-title submenu-title"
                                                                                translate>
                                                                                {{
                                                                                    innersubmenu.menu
                                                                                }}
                                                                            </span>
                                                                        </a>
                                                                    </ng-container>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </nav>
        <nav
            id="nav"
            role="navigation"
            class="navigation-section second-navigation-section">
            <div class="menu-items">
                <ng-container *ngFor="let menu of menuList">
                    <ng-container *accessControl="menu.accessControl">
                        <div
                            *ngIf="
                                customCondition(menu) &&
                                (['image', 'profilelogo', 'button'].includes(
                                    menu.type
                                ) ||
                                    ['image', 'profilelogo'].includes(
                                        menu.menu
                                    ))
                            ">
                            <div class="menu-list">
                                <!-- Button (not popup) -->
                                <div
                                    [ngClass]="menu.class"
                                    *ngIf="
                                        menu.type == 'button' &&
                                        menu.outputType != 'popup'
                                    ">
                                    <button
                                        class="non-drp-down app-c-btn app-c-btn--curve app-c-btn--sm app-c-btn--white"
                                        (click)="menuService.nav(menu.path)"
                                        (keydown.enter)="
                                            menuService.nav(menu.path)
                                        "
                                        [attr.aria-label]="
                                            menu.menu | translate
                                        "
                                        tabindex="0">
                                        <svg-icon
                                            [icon]="menu.name"
                                            [alt]="null"></svg-icon>
                                        <span translate>{{ menu.menu }}</span>
                                    </button>
                                </div>

                                <!-- Button (popup) -->
                                <div
                                    *ngIf="
                                        menu.type == 'button' &&
                                        menu.outputType == 'popup'
                                    "
                                    [ngClass]="menu.class"
                                    class="share-button">
                                    <button
                                        class="non-drp-down app-c-btn app-c-btn--curve app-c-btn--sm app-c-btn--white"
                                        *ngIf="showShare"
                                        [attr.aria-label]="
                                            menu.menu | translate
                                        "
                                        (click)="modalFunction(menu.menu)"
                                        tabindex="0">
                                        <svg-icon
                                            [icon]="menu.name"
                                            [alt]="null"></svg-icon>
                                        <span translate>{{ menu.menu }}</span>
                                    </button>
                                </div>

                                <div class="menu-list-wrap">
                                    <!-- Image -->
                                    <div
                                        class="app-l-menu__over"
                                        *ngIf="
                                            menu.subMenu.length == '0' &&
                                            menu.type == 'image'
                                        ">
                                        <span
                                            class="app-l-menu__icon non-drp-down"
                                            tabindex="0"
                                            [attr.aria-label]="
                                                menu.menu | translate
                                            "
                                            routerLinkActive="active"
                                            [routerLinkActiveOptions]="{
                                                exact:
                                                    menu.imageIcon.alt ===
                                                    'Dashboard',
                                            }"
                                            (click)="menuService.nav(menu.path)"
                                            (keydown.enter)="
                                                menuService.nav(menu.path)
                                            ">
                                            <svg-icon
                                                [icon]="menu.imageIcon.name"
                                                class="w-100 h-100"
                                                [alt]="null">
                                            </svg-icon>
                                        </span>
                                    </div>

                                    <!-- Dropdown (profile) -->
                                    <div
                                        class="dropdown profile"
                                        *ngIf="menu.menu === 'profilelogo'"
                                        tabindex="0"
                                        aria-haspopup="true"
                                        [attr.aria-expanded]="menu.showSubMenu"
                                        aria-label="User profile menu"
                                        (click)="toggleSubMenu(menu)"
                                        role="button"
                                        (keydown.enter)="toggleSubMenu(menu)">
                                        <div
                                            class="profile-picture"
                                            [ngClass]="{
                                                'profile-open':
                                                    menu.showSubMenu,
                                            }">
                                            <span
                                                >{{ firstNameInitial
                                                }}{{ lastNameInitial }}</span
                                            >
                                            <div class="status"></div>
                                        </div>

                                        <div
                                            class="submenu-container"
                                            [ngClass]="{
                                                show: menu.showSubMenu,
                                            }"
                                            role="menu">
                                            <div class="app-l-profile__info">
                                                <div
                                                    class="app-l-profile__avatar">
                                                    <img
                                                        src="/assets/img/profile-logo.svg"
                                                        alt="Profile avatar" />
                                                </div>
                                                <div class="app-l-profile__cnt">
                                                    <h3
                                                        class="app-c-body-text--15-m">
                                                        {{ user.firstName
                                                        }}{{ user.lastName }}
                                                    </h3>
                                                    <span
                                                        class="app-c-body-text--13"
                                                        >{{ user.email }}</span
                                                    >
                                                </div>
                                            </div>

                                            <!-- Submenus -->
                                            <div
                                                class="dropdown-content"
                                                *ngFor="
                                                    let submenu of menu.subMenu
                                                "
                                                [ngClass]="{
                                                    show: menu.showSubMenu,
                                                }"
                                                tabindex="0"
                                                role="menuitem"
                                                [attr.aria-label]="submenu.menu | translate">
                                                <a
                                                    translate
                                                    tabindex="0"
                                                    [ngClass]="submenu.class"
                                                    routerLinkActive="active"
                                                    [routerLinkActiveOptions]="{
                                                        exact:
                                                            submenu.imageIcon
                                                                .alt ===
                                                            'Dashboard',
                                                    }"
                                                    (click)="
                                                        submenu.outputType ==
                                                        'popup'
                                                            ? modalFunction(
                                                                  submenu
                                                                      .imageIcon
                                                                      .alt
                                                              )
                                                            : menuService.nav(
                                                                  submenu.path
                                                              )
                                                    "
                                                    (keydown.enter)="
                                                        submenu.outputType ==
                                                        'popup'
                                                            ? modalFunction(
                                                                  submenu
                                                                      .imageIcon
                                                                      .alt
                                                              )
                                                            : menuService.nav(
                                                                  submenu.path
                                                              )
                                                    ">
                                                    <span
                                                        class="app-l-menu__icon"
                                                        [attr.aria-label]="submenu.menu | translate"
                                                        role="presentation">
                                                        <svg-icon
                                                            [icon]="
                                                                submenu
                                                                    .imageIcon
                                                                    .name
                                                            "
                                                            class="w-100 h-100"
                                                            [alt]="null">
                                                        </svg-icon>
                                                    </span>
                                                    <span
                                                        class="submenu-title"
                                                        translate
                                                        >{{
                                                            submenu.menu
                                                        }}</span
                                                    >
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <!-- <div class="menu-list">
					<language-dropdown
						[color]="'white'"
						[page]="'inside'"
						*ngIf="!menuService.disableLanguage"
						class="language-dropdown-section"
					></language-dropdown>
				</div> -->
            </div>
        </nav>
    </div>
</div>
